import React from 'react';
import { HeaderText, Button2, Switcher } from '@el8/vital';
import { Box, LoginPopover, Card } from 'components';
import PatientDetailsForm from 'views/account/PatientDetailsForm';

import { PatientChartInfo } from 'types';
import styles from './LoginCard.less';

type OwnProps = {
  patientInfo: PatientChartInfo;
  practiceId: number;
  setPatientDetails: (values: PatientChartInfo) => void;
};

type Props = OwnProps;

const LoginCard: React.FC<Props> = ({ setPatientDetails, patientInfo, practiceId }) => {
  return (
    <Card>
      <Box direction="column" align="center">
        <Switcher gap="xs" threshold="32rem">
          <HeaderText
            style={{
              fontSize: 'var(--vds-font-base-size-400)',
              textAlign: 'center',
            }}
            tag="h2"
            legacyVariant="legacyTitleText"
            sizing="heading-lg"
          >
            Have an account?
          </HeaderText>
          <div style={{ textAlign: 'center' }}>
            <LoginPopover forceChartSelection practiceId={practiceId}>
              <Button2 kind="primary" label="Login to Passport" />
            </LoginPopover>
          </div>
        </Switcher>
        <Box className={styles.form} direction="column">
          <Box align="center" justify="center" style={{ marginBottom: 'var(--vds-space-lg)' }}>
            <Box style={{ width: '100%', height: 1, backgroundColor: 'var(--vds-surface-200)' }} />
            <HeaderText
              style={{
                paddingLeft: 'var(--vds-padding-xs)',
                paddingRight: 'var(--vds-padding-xs)',
                fontSize: 'var(--vds-font-base-size-400)',
                whiteSpace: 'nowrap',
              }}
              tag="h2"
              legacyVariant="legacyTitleText"
              sizing="heading-lg"
            >
              Continue as Guest
            </HeaderText>
            <Box style={{ width: '100%', height: 1, backgroundColor: 'var(--vds-surface-200)' }} />
          </Box>
          <PatientDetailsForm patientInfo={patientInfo} setPatientDetails={setPatientDetails} />
        </Box>
      </Box>
    </Card>
  );
};

export default LoginCard;
